import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaTachometerAlt, FaUser, FaServer, FaExclamationTriangle, FaRegClipboard, FaCogs } from 'react-icons/fa';
import './Navbar.css';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../components/ThemeContext'; // Import useTheme

const Navbar = () => {
  const { user, logout } = useAuth();
  const [role, setRole] = useState(user?.role || '');
  const { theme, toggleTheme } = useTheme(); // Destructure theme and toggleTheme
  const [isNavOpen, setIsNavOpen] = useState(false);

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        if (user?.role) {
          setRole(user.role);
          return;
        }

        if (user?.authType === 'email') {
          setRole(user.role || 'normal');
          return;
        }
      } catch (error) {
        console.error('Error fetching user role:', error);
        setRole((prev) => prev || user?.role || 'normal'); // fall back without clearing admin
      }
    };

    if (user) {
      fetchUserRole();
    }
  }, [user]);

  const handleLogout = () => {
    logout();
  };

  const logoSrc = '/MBS-Monitoring-Logo.svg';
  const closeNav = () => setIsNavOpen(false);
  const toggleNav = () => setIsNavOpen((prev) => !prev);

  useEffect(() => {
    document.body.style.overflow = isNavOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isNavOpen]);

  return (
    <>
      <div className={`mobile-nav-header ${theme}`}>
        <button
          className={`mobile-nav-toggle ${theme} ${isNavOpen ? 'open' : ''}`}
          onClick={toggleNav}
          aria-label="Toggle navigation"
          aria-expanded={isNavOpen}
        >
          <span className="sr-only">Toggle navigation</span>
          <span className="hamburger" aria-hidden="true" />
        </button>
      </div>

      <div className={`nav-overlay ${isNavOpen ? 'show' : ''}`} onClick={closeNav} />

      <nav className={`dashboard-nav ${theme} ${isNavOpen ? 'open' : ''}`}>
        <div className="logo-container">
          <img src={logoSrc} alt="MBS Monitoring" className="logo" />
        </div>
        <ul>
          <li>
            <NavLink to="/dashboard" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeNav}>
              <FaTachometerAlt className="nav-icon" /> Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink to="/profile" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeNav}>
              <FaUser className="nav-icon" /> Profile
            </NavLink>
          </li>
          {role === 'admin' && (
            <li>
              <NavLink to="/Environments" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeNav}>
                <FaServer className="nav-icon" /> Environments
              </NavLink>
            </li>
          )}
          <li>
            <NavLink to="/Servers" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeNav}>
              <FaCogs className="nav-icon" /> Servers
            </NavLink>
          </li>
          <li>
            <NavLink to="/request" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeNav}>
              <FaRegClipboard className="nav-icon" /> Request
            </NavLink>
          </li>
          {role === 'admin' && (
            <li>
              <NavLink to="/alert" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeNav}>
                <FaExclamationTriangle className="nav-icon" /> Alert
              </NavLink>
            </li>
          )}
          {role === 'admin' && (
            <li>
              <NavLink to="/Users" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeNav}>
                <FaRegClipboard className="nav-icon" /> Users
              </NavLink>
            </li>
          )}
        </ul>
        <div className="logout-container">
          <button className="logout-button" onClick={handleLogout}>
            Logout
          </button>
          <button className="theme-toggle" onClick={toggleTheme}>
            Toggle Theme
          </button>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
